import { IScheduledTimingRepeat } from './ischeduled-timing-repeat';
export interface IFrequency {
    frequencyIdentifier: string;
    frequencyName: string;
    tenantId: number;
    language: string;
    scheduledTimingRepeat: IScheduledTimingRepeat[];
}